import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page_404" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-10 col-sm-offset-1 text-center\"><div class=\"four_zero_four_bg\"><h1 class=\"text-center\">404</h1></div><div class=\"contant_box_404\"><h3 class=\"h2\">Look like you&#39;re lost</h3><p>the page you are looking for not available!</p><a href=\"/\" class=\"link_404\">Go to Home</a></div></div></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundPage',
  setup(__props) {

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}
}

})